<template>
    <div class="forgetP">
        <div class="outer" v-if="isLogin">
            <div class="img-div-outer">
                <img :src="require('@/assets/logo/outer.png')" alt />
                <div class="inner text-center">
                    <el-tabs v-model="activeName" @tab-click="handleClick" class="my-tab" stretch>
                        <el-tab-pane label="手机号找回"  name="first" >
                            <el-form ref="form" :model="form" :rules="rules">
                                <el-form-item prop="phone">
                                    <el-input
                                        placeholder="手机号"
                                        v-model="form.phone"
                                        class="first-input my-input"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item prop="yzm">
                                    <el-input placeholder="验证码" v-model="form.yzm" class="yzm">
                                        <el-button
                                            slot="append"
                                            :disabled="disabledyzm"
                                            @click="sjGetYZM()"
                                        >{{btntxt}}</el-button>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="password">
                                    <el-input
                                        placeholder="密码"
                                        v-model="form.password"
                                        class="second-input my-input"
                                        type="password"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item prop="spassword">
                                    <el-input
                                        placeholder="确认密码"
                                        v-model="form.spassword"
                                        class="second-input my-input"
                                        type="password"
                                    ></el-input>
                                </el-form-item>

                                <el-form-item>
                                    <button
                                        class="btn-center login-button"
                                        type="button"
                                        @click="submitFuncSJ('form')"
                                    >确认</button>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane label="邮箱找回" name="second">
                            <el-form ref="form1" :model="form1" :rules="rules1">
                                <el-form-item prop="email">
                                    <el-input
                                        placeholder="邮箱号"
                                        v-model="form1.email"
                                        class="first-input my-input"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item prop="yzm">
                                    <el-input placeholder="验证码" v-model="form1.yzm" class="yzm">
                                        <el-button
                                            slot="append"
                                            :disabled="disabledyzm1"
                                            @click="yxGetYZM()"
                                        >{{btntxt1}}</el-button>
                                        <!-- <template slot="append" @click="getYZM()">获取</template> -->
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="password">
                                    <el-input
                                        placeholder="密码"
                                        v-model="form1.password"
                                        class="second-input my-input"
                                        type="password"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item prop="spassword">
                                    <el-input
                                        placeholder="确认密码"
                                        v-model="form1.spassword"
                                        class="second-input my-input"
                                        type="password"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <button
                                        class="btn-center login-button"
                                        type="button"
                                        @click="submitFuncYZ('form1')"
                                    >确认</button>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                       
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import rules from "@/common/rules";

export default {
    name: "forgetP",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.form.spassword !== "") {
                    // this.$refs.user.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.form.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };

        var validatePass3 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.form1.spassword !== "") {
                    // this.$refs.user.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass4 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.form1.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            // 手机号找回验证
            rules: {
                password: [
                    { validator: validatePass, trigger: "blur" },
                    {
                        min: 6,
                        max: 20,
                        message: "长度在 6 到 20 个字符",
                        trigger: "blur"
                    }
                ],
                spassword: [
                    { validator: validatePass2, trigger: "blur" },
                    {
                        min: 6,
                        max: 20,
                        message: "长度在 6 到 20 个字符",
                        trigger: "blur"
                    }
                ],
                yzm: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur"
                    },
                    {
                        validator: rules.FormValidate.Form().validatePhone,
                        trigger: ["blur", "change"]
                    }
                ]
            },
            // 邮箱找回验证
            rules1: {
                password: [
                    { validator: validatePass3, trigger: "blur" },
                    {
                        min: 6,
                        max: 20,
                        message: "长度在 6 到 20 个字符",
                        trigger: "blur"
                    }
                ],
                spassword: [
                    { validator: validatePass4, trigger: "blur" },
                    {
                        min: 6,
                        max: 20,
                        message: "长度在 6 到 20 个字符",
                        trigger: "blur"
                    }
                ],
                yzm: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    }
                ],
                email: [
                    {
                        required: true,
                        type: "email",
                        message: "请输入正确的邮箱",
                        trigger: "blur"
                    }
                ]
            },
            // 手机号找回表单
            form: {
                phone: "",
                yzm: "",
                password: "",
                spassword: ""
            },
            // 邮箱找回表单
            form1: {
                email: "",
                yzm: "",
                password: "",
                spassword: ""
            },
            activeName: "first",

            isLogin: true,
            btntxt: "获取验证码",
            disabledyzm: false,
            time: 60,
            btntxt1: "获取验证码",
            disabledyzm1: false,
            time1: 60,
            checked: false
        };
    },
    methods: {
        handleClick(tab, event) {},
        //多少秒后重新获取验证码
        timeryzm1() {
            if (this.time1 > 0) {
                this.time1--;
                // console.log(this.time);
                this.btntxt1 = this.time1 + "s";
                setTimeout(this.timeryzm1, 1000);
            } else {
                this.time1 = 60;
                this.btntxt1 = "重新获取";
                this.disabledyzm1 = false;
            }
        },

        // 邮箱获取验证码
        yxGetYZM() {
            let that = this;
            if (!that.form1.email) {
                that.$message.error("请先输入邮箱");
                return false;
            }
            let url = "/user/sendCodeToEmail";
                    let params = {
                        email: that.form1.email
                    };
                    that.$http
                        .post(url, params)
                        .then(res => {
                    if (res.data.code == 200) {
                        that.disabledyzm1 = true;
                        that.timeryzm1();
                        that.$message({
                            message: "验证码发送成功",
                            type: "success"
                        });
                    } else {
                        that.$message.error(res.data.msg);
                    }
                })
                .catch(() => {
                    that.$message.error("网络错误！");
                });
        },
        // 手机号获取验证码
        sjGetYZM() {
            let that = this;
            if (!that.form.phone) {
                that.$message.error("请先输入手机号");
                return false;
            }
            let url = "user/phone/sendCodeToPhoneAccount";
            let params = {};
            params.phone = that.form.phone;
            that.$http
                .post(url, params)
                .then(res => {
                    if (res.data.code == 200) {
                        that.disabledyzm = true;
                        that.timeryzm();
                        that.$message({
                            message: res.data.msg,
                            type: "success"
                        });
                    }else{
                         that.$message.error(res.data.msg);
                    }
                })
                .catch(() => {
                });
        },
        // 邮箱找回确定
        submitFuncYZ(form) {
            let that = this;
            that.$refs[form].validate(valid => {
                if (valid) {
                    let url = "user/forgetPasswordByEmail";
                    let params = {
                        email: that.form1.email,
                        temp: that.form1.yzm,
                        password: that.form1.password,
                        activityChannel: "0"
                    };
                    that.$http
                        .post(url, params)
                        .then(res => {
                            if (res.data.code == 200) {
                                this.$message({
                                    message: "邮箱找回密码成功",
                                    type: "success"
                                });
                                that.$router.go(-1);
                            } else {
                                that.$message.error(res.data.msg);
                            }
                        })
                        .catch(() => {
                            that.$message.error("网络错误！");
                        });
                }
            });
        },
        // 手机找回确定
        submitFuncSJ(form1) {
            let that = this;
            that.$refs[form1].validate(valid => {
                if (valid) {
                    let url = "/user/forgetPasswordByPhone";
                    let params = {
                        phone: that.form.phone,
                        temp: that.form.yzm,
                        password: that.form.password,
                        activityChannel: "0"
                    };
                    that.$http
                        .post(url, params)
                        .then(res => {
                            if (res.data.code == 200) {
                                this.$message({
                                    message: "手机找回密码成功",
                                    type: "success"
                                });
                                that.$router.go(-1);
                            } else {
                                that.$message.error(res.data.msg);
                            }
                        })
                        .catch(() => {
                            that.$message.error("网络错误！");
                        });
                }
            });
        }
    },
    created() {}
};
</script>

<style scoped>
.forgetP {
    background: url(../assets/logo/bg.jpg) no-repeat center center;
}
.set-margin {
    margin-top: 20px;
}
.two {
    font-size: 14px;
    padding-bottom: 20px;
    cursor: pointer;
}
.login {
    background: url(../assets/logo/bg.jpg) no-repeat center center;
}

.outer {
    padding: 50px 0px;
    height: 415px;
    /* background: url(../assets/logo/outer.png) no-repeat center center; */
    position: relative;
    margin: 0 auto;
}
.img-div-outer {
    width: 814px;
    margin: 0 auto;
    position: relative;
}
.inner {
    position: absolute;
    top: 35px;
    right: 6%;
    width: 266px;
}
.inner1 {
    top: 65px;
}
.login-button {
    width: 100%;
    height: 46px;
    background-color: #f64320;
    border-radius: 2px;
    color: #fff;
    border: 1px solid #f64320;
}
.login-button:focus {
    border: 1px solid #f64320 !important;
}
.weixin {
    display: inline-block;
    vertical-align: middle;
}
.refresh-icon {
    background-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/forgetP.vue